import { DynamicTable } from '@etiquette-ui/dynamic-table';
import styled from 'styled-components';

const Table = styled(DynamicTable)`
  height: 100%;
  background-color: transparent;
  background: transparent;
`;

export default Table;